export default "__VITE_ASSET__DtMffoYA__"